import React, { useState, useEffect } from 'react';

export default function ColumnMapperModal({ 
  excelHeaders, defaultCols, onSave, onCancel, api, user, selectedBase, sheetName
}) {

  const [mapping, setMapping] = useState({});

  const [templates, setTemplates] = useState([]);

  const handleSave = () => onSave(mapping);
  
  const handleChange = (key, userCol) => {
    setMapping(m => ({ ...m, [key]: userCol }));
  };
      
  // auto‑match suggestions
  useEffect(() => {
    const stored = localStorage.getItem(`ato-mapping-${sheetName}`);
    if (stored) setMapping(JSON.parse(stored));
    else {
      // fallback to auto-suggest
      const suggestion = {};
      defaultCols.forEach(col => {
        const best = excelHeaders.find(h =>
          h.toLowerCase().includes(col.label.toLowerCase())
        );
        if (best) suggestion[col.key] = best;
      });
      setMapping(suggestion);
    }
  }, []); // empty deps to avoid re-running

  useEffect(() => {
    api.get("/get-mappings", {
      params: { email: user.email, location: selectedBase }
    })
    .then(res => setTemplates(res.data.templates || []))
    .catch(console.error);
  }, []);


  return (
    <div className="modal-overlay">
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#fff', padding: '20px', borderRadius: '8px',
        maxHeight: '80vh', overflowY: 'auto', zIndex: 1000
      }}>
        <h3>Map Your Columns</h3>
        {/* Template loader dropdown */}
        {templates.length > 0 && (
          <div style={{ marginBottom: '12px' }}>
            <label style={{ marginRight: 8 }}>Load Saved Template:</label>
            <select
              onChange={e => {
                const selected = templates.find(t => t.id === e.target.value);
                if (selected) setMapping(selected.mapping);
              }}
              defaultValue=""
            >
              <option value="">-- Select a template --</option>
              {templates.map(t => (
                <option key={t.id} value={t.id}>
                  {t.name} (by {t.owner})
                </option>
              ))}
            </select>
          </div>
        )}
        <table style={{ width: '100%', marginBottom: '16px' }}>
          <thead>
            <tr><th>App Field</th><th>Your Column</th></tr>
          </thead>
          <tbody>
            {defaultCols.map(col => (
              <tr key={col.key}>
                <td>{col.label}</td>
                <td>
                  <select
                    value={mapping[col.key] || ''}
                    onChange={e => handleChange(col.key, e.target.value)}>
                    <option value="">-- select --</option>
                    {excelHeaders.map(h => (
                      <option key={h} value={h}>{h}</option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button onClick={handleSave}>Import</button>
          <button onClick={() => {
            const name = prompt("Enter a name for this mapping template:");
            if (!name) return;
            const payload = {
              name,
              mapping,
              location: selectedBase, // pass via props
              user: user.email,
              sharedWith: [] // you can build UI for this later
            };
            api.post("/save-mapping", payload)
               .then(() => alert("Template saved!"))
               .catch(err => {
                 console.error("Failed to save mapping:", err);
                 alert("Save failed");
               });
          }}>💾 Save as Template</button>
          <button onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}